// src/helpers/headerActions.js

export function resolvePrimaryAction (page, context) {
  const { team, person_id: personId } = context

  switch (page) {
    case 'team':
      return { name: 'team_edit', params: { team_id: team.id } }
    case 'club':
      return { name: 'club_edit' }
    case 'players':
      return { name: 'players_add', params: { id: team.team.id } }
    case 'staff':
      return { name: 'staff_add', params: { id: team.team.id } }
    case 'acompanyants':
      return { name: 'acompanyants_add', params: { id: team.team.id } }
    case 'player':
      return { name: 'player_edit', params: { person_id: personId } }
    case 'coach':
      return { name: 'staff_edit', params: { person_id: personId } }
    case 'acompanyant':
      return { name: 'acompanyant_edit', params: { person_id: personId } }
    case 'responsable':
      return { name: 'responsable_edit', params: { person_id: personId } }
    case 'participant':
      return { name: 'participant_edit', params: { person_id: personId } }
    case 'documents':
      return { name: 'participant_campus_edit', params: { person_id: personId } }
    // emit-driven cases
    case 'team_edit':
    case 'club_edit':
    case 'participant_edit':
    case 'participant_campus_edit':
    case 'campus_rooms':
    case 'credential_update':
    case 'campus_training':
      context.$emit('update'); return null
    case 'players_add':
    case 'player_edit':
    case 'staff_add':
    case 'staff_edit':
    case 'acompanyants_add':
    case 'acompanyant_edit':
      context.$emit('validate')
      return null
    case 'gestor':
      context.$emit('add'); return null
    case 'uniforms':
      context.$emit('uniformForm'); return null
    case 'image-rights':
      context.$emit('download'); return null
    case 'payments':
      context.$emit('print'); return null
  }

  return null
}

export function resolveSecondaryAction (page, context) {
  const { team, person_id: personId, user, action_two: actionTwo } = context

  switch (page) {
    case 'team_edit':
      return { name: 'team', params: { team_id: team.id } }
    case 'club_edit':
      return { name: 'club' }
    case 'gestor':
      return { name: 'team', params: { id: team.team ? team.team.id : team.id } }
    case 'players_add':
    case 'player_edit':
      return { name: 'players', params: { team_id: team.team.id } }
    case 'staff_add':
    case 'staff_edit':
      return { name: 'staff', params: { team_id: team.team.id } }
    case 'acompanyants_add':
    case 'acompanyant_edit':
      return { name: 'acompanyants', params: { team_id: team.team.id } }
    case 'team':
      if (actionTwo === 'add_gestor') return { name: 'gestorAdd', params: { team_id: team.id } }
      if (actionTwo === 'delete_gestor') { context.$emit('delete_gestor'); return null }
      break
    case 'participant':
      return { name: 'participant_campus_edit', params: { person_id: personId } }
    case 'participant_edit':
    case 'participant_campus_edit':
    case 'campus_rooms':
    case 'campus_training':
      return { name: 'campus_home', params: { campus_id: user.campus_id } }
  }

  return null
}
